import React, { useEffect, useState } from "react";
import Navbar from "@modules/Navbar/index";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { createTheme } from "@mui/material/styles";
import { fonts, themeColors, typographyScale } from "@app/themes/index";
import { StyledLayout, GlobalContainer } from "./Layout.styles.js";
import Footer from "@modules/Footer/Footer.jsx";
import { ThemeModeContext } from "../../context/ThemeModeContext";
import content from "@app/content/content-en.js";
import FinalSection from "@modules/Home/components/FinalSection/FinalSection";

/* The theme's body font on the document root, so text outside the layout
   (portals, pop-ups) picks it up too. */
const GlobalFonts = createGlobalStyle`
  html {
    font-family: ${({ theme }) => theme.fonts.body};
    font-weight: 300;
  }
`;

const onResize = () => {
  const root = window.document.documentElement;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  root.style.setProperty("--screen-w", screenWidth);
  root.style.setProperty("--screen-h", screenHeight);
};

function Layout({ children, location }) {
  const [mode, setMode] = useState("light");

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  const styledComponentTheme = themeColors[mode];
  const theme = createTheme({
    palette: {
      primary: styledComponentTheme.primary,
      secondary: styledComponentTheme.secondary,
      text: styledComponentTheme.text,
      background: styledComponentTheme.background,
      redesign: styledComponentTheme.redesign,
    },
    colors: { ...styledComponentTheme.colors },
    fonts,
    typography: {
      fontFamily: fonts.body,
      scale: typographyScale,
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        mobile: 0,
        tablet: 640,
        laptop: 1024,
        laptopL: 1440,
        desktop: 1200,
      },
    },
  });

  useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return (
    <ThemeModeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <GlobalFonts />
        <StyledLayout>
          <GlobalContainer>
            <Navbar pathname={location?.pathname} />
            <main>{children}</main>
            <FinalSection 
              content={content.finalSection} 
              navigateToGetApp={() => window.open(process.env.GATSBY_WEBAPP_BASE_URL, '_blank')} 
            />
            <Footer />
          </GlobalContainer>
        </StyledLayout>
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
}

export default Layout;
